var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_2669",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_2669",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAABElJREFUaEPtmVuoTUEYx233XB6kSFEn4UWhkAdROCmFB3IrdHJ7IbcID3JSCoXEAzrpuJQiSkTJ4fAg8YAoUoeSXHM/7pft/9Pe+s7Ye63Z67IPZerfWrPWzDfff+abb76ZyWSz2RZBKZPJBP5vrp95vTP/KgF1HLpnm4tAVynQS+ghdAoYxbf6Vy98dss0xwig7HxhgjCYHvQ0v4sqN0r4YcuXkwA9vEZYInT0VNot1lsf7uc/WrNP24Qq1OhxYUBExan2SugpfCg3gf5q8JzQrYDy3/XtlvBIaAwgx789wuVC5sO3tEaASXpFYOhteqjMBuGI8CLqqJTDhE5IufGOgoeVrxI+RlW8XCaEx8B0bNqpzGIheNX0ZJb2COD2RhhdLuh9jIDdJ5LSJMCEfSy0zGmK7x4iXEtEc4bQCX2SnsSz1MZ+o+wlvQ9PSnnk/EHAEU7P0YsdnO9vlPfxGtUqt87U5X19OQiwWtJQldClSIO4vulCkyXdKbtZ+ZXmG6FDTRwCocFmrrfr9Rzq0dBolTkfUG63/i0w/6fqHeKRkw8Ben6tRwvfVIbV9e7fRqBBCtkV86byTx0liUP2CsQ1QSnREQjrfRQhpKVnWxmt2un9i8eIFCqSKAEaCCMBAXd19I3T/xkC+HF8O7H8CuFgQnOAUd8izBFuCJOFZ67sJEaAVXRQTjAudKZwqAgJXxNilAmT5xk5uOBVheQGkfAxIUsA+V+FScLJAo35Etiqusuc+tuUX15sdH9vIc0pCd98COD7TwttjfBPeh8n1DsN+hCoVh27WiPigTBMeFKMQLGR8SFA3SkCZmO91TvliTKvGuFhBOhh7N4mXPZIIWh9KcrLlwACmGyEBdZLvVS+UshHm0EEZqtcrVP/tfLsH66X0vO2bCkEqIfdYr82Pc/14B09ixGYoX94stam4nu9jxWIWCOnUgnQ0EbB9RbsdTGD1YIbCzFfjgptjJYcVE0UzkTWPFcxCgGqskVc6DROSHJbsHvhXcpXCe1NWXZmBHnH4ipP/agE2DfsE1gTSkms+syl2lIqBZWNSgCZ2DOmgSn4pqUquN23sE+5OASQj2mcEvAkYWmTCjBHEk1xCaBMZ6FOCNoQBa6ycRglQYD2OYk7K+RjJqsT+whinkTOhFyySRFAbneBM6F+phG2k6wBiZ0JpUkA2VxaEG4PFAg9OFJ3N0e4WdwrIzJXiLUWxBqBQmGux50aJ9JcdpAaJKOP26ul5BMj4KF4Xq8mc4FrrlIUTtuEfHT5T8D2UiETIkxIxeVJLu25l3WxTYhrHHv5huu752MLEcpUqM40U69Rc4CFMHKCPZcRPqFA5EYCKtaJABuiyAkCbAvxxfkz/cjCSqyIKVWKQNBZa6jIvP2xCdkh2I17aOUYBdjQLBJqws59wtqwE4jzUS4o+qZIhFWZzfsB4dfFdWwCcQWE9VDa/0OvmNJWIK78n6qsY9TWzh2nAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon2);
export default __webpack_public_path__ + "static/media/shareIcon2.1d9caeff711fcbd43103a810ea66410c.svg";
export { ForwardRef as ReactComponent };